import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * US SSN validator following Single Responsibility Principle
 */
export class SsnValidator extends BaseValidator {
  constructor() {
    super({
      name: 'US Social Security Number',
      pattern: /^\d{3}-?\d{2}-?\d{4}$/,
      length: 9
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    const patternValidation = this.validateRegex(
      id,
      this.config.pattern,
      'SSN format must be XXX-XX-XXXX or XXXXXXXXX'
    );
    if (!patternValidation.isValid) {
      return patternValidation;
    }

    // Check for invalid patterns
    const area = cleanId.substring(0, 3);
    const group = cleanId.substring(3, 5);
    const serial = cleanId.substring(5, 9);

    if (area === '000' || area === '666' || area.startsWith('9')) {
      return ValidationResult.invalid('Invalid SSN area number');
    }

    if (group === '00') {
      return ValidationResult.invalid('Invalid SSN group number');
    }

    if (serial === '0000') {
      return ValidationResult.invalid('Invalid SSN serial number');
    }

    return ValidationResult.valid();
  }

  validateChecksum(id) {
    // SSN doesn't have a checksum, validation is format-based
    return ValidationResult.valid('Valid SSN');
  }
}